import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getCropLiveTradeData,
  ICropLiveTradeDataParams,
  ICropLiveTradeData,
} from '../../../api/crop-trends/getCropLiveTradeData';

interface IUseGetCropLiveTradeDataQueryParams extends ICropLiveTradeDataParams {
  options?: UseInfiniteQueryOptions<ICropLiveTradeData[], AxiosError>;
}

export const useGetCropLiveTradeData = ({ searchParam, options }: IUseGetCropLiveTradeDataQueryParams) => {
  return useInfiniteQuery<ICropLiveTradeData[], AxiosError>(
    [
      'crop-live-trade-data',
      `wholesaleMarketCode=${searchParam.wholesaleMarketCode}`,
      `largeCategoryCode=${searchParam.largeCategoryCode}`,
      `middleCategoryCode=${searchParam.middleCategoryCode}`,
      `smallCategoryCode=${searchParam.smallCategoryCode}`,
      `page=${searchParam.page}`,
      `count=${searchParam.count}`,
    ],
    ({ pageParam = 1 }) => getCropLiveTradeData({ searchParam: { ...searchParam, page: pageParam } }),
    {
      ...options,
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = allPages.length + 1;
        return lastPage?.length === 0 || lastPage?.length < searchParam.count ? undefined : nextPage;
      },
    },
  );
};
